import * as actionTypes from '../../types/payments';

import { getSearchUsersList } from '../../../services/endpoints/payments';

/**
 * @function local
 * @name getUsersList
 * @param {string} query - search string for request
 */
export const getUsersList = (query) => async (dispatch) => {
  dispatch({ type: actionTypes.GET_USERS_LIST_SEARCH });

  try {
    const response = await getSearchUsersList(query);
    const { data } = response;

    dispatch({
      type: actionTypes.GET_USERS_LIST_SEARCH_SUCCESS,
      data,
    });

    return data;
  } catch (error) {
    dispatch({ type: actionTypes.GET_USERS_LIST_SEARCH_ERROR, error });
  }
};
